import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, ElementRef, ViewChild, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FiletypeDropdownComponent } from 'src/app/components/file-type-selector/file-type-selector.component';
import { FileTypeInfo, SupportedFileTypes } from 'src/app/models/file-type.models';

@Component({
  selector: 'tx-send-document-dialog',
  templateUrl: './send-document-dialog.component.html',
  styleUrls: ['./send-document-dialog.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state(
        'void',
        style({
          height: '0',
          overflow: 'hidden',
          opacity: '0',
        })
      ),
      state(
        '*',
        style({
          height: '*',
          overflow: 'hidden',
          opacity: '1',
        })
      ),
      transition('void <=> *', animate(150)),
    ]),
  ],
})
export class SendDocumentDialogComponent {
  @Input() isPdf: boolean = false;
  public description: string = '';
  public clientName: string = '';
  public caseName: string = '';
  public fileName: string = '';
  public existingFiles: string[] = [];
  public extension: FileTypeInfo = SupportedFileTypes[0];
  public fileNameInvalid: boolean = false;
  @ViewChild('descriptionOfClientDocument') descriptionElement!: ElementRef;
  constructor(public activeModal: NgbActiveModal) {}
  ngOnInit() {}
  ngAfterViewInit() {
    console.log(`after view init - input isPdf = `, this.isPdf);
    if (this.existingFiles.some((x) => x.toLowerCase() === this.fileName.toLowerCase())) {
      this.invalidateFields();
    } else {
      this.validateFields();
    }
    setTimeout(() => {
      this.descriptionElement.nativeElement.focus();
    });
  }

  handleFileNameChange(newFileName: string) {
    if (this.existingFiles.some((x) => x.toLowerCase() === newFileName.toLowerCase())) {
      this.invalidateFields();
    } else {
      this.validateFields();
    }
  }

  validateFields() {
    this.fileNameInvalid = false;
  }
  invalidateFields() {
    this.fileNameInvalid = true;
  }

  extensionChange(extension: FileTypeInfo) {
    this.extension = extension;
  }
}
